<script setup lang="ts">
import ModalContainer from '@/components/modal/modal-container.vue'
import { ref } from 'vue'
import AddManualAssetModalLookup from '@/features/assets/components/partials/AddManualAssetModalLookup.vue'
import AddManualAssetModalConfirm from '@/features/assets/components/partials/AddManualAssetModalConfirmation.vue'
import type { checkAssetCreationEligibility } from '@/features/assets/api/checkAssetCreationEligibility'

type LookupData = Awaited<ReturnType<typeof checkAssetCreationEligibility>>

defineEmits<{ close: [] }>()


const lookup = ref<LookupData>()

</script>

<template>
  <ModalContainer>
    <AddManualAssetModalLookup v-if="!lookup"
                               @close="$emit('close')"
                               v-model:details="lookup" />

    <AddManualAssetModalConfirm v-else-if="lookup"
                                :details="lookup"
                                @close="$emit('close')" />
  </ModalContainer>
</template>

<style scoped lang="scss">

</style>
